// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d71886b","455":"1d73e498","977":"13f46a5c"}[chunkId] + ".chunk.js";
};